export const DEFAULT_TRIAL_DAYS = 14
export const DEFAULT_TRIAL_WEEKS = 2
export const TRIAL_ACCESS_COPY = "2 weeks free unlimited access"

export const addTrialDays = (startDate) => {
  if (!startDate) return ""

  const [year, month, day] = startDate.split("-").map(Number)
  const date = new Date(Date.UTC(year, month - 1, day))
  date.setUTCDate(date.getUTCDate() + DEFAULT_TRIAL_DAYS)
  return date.toISOString().slice(0, 10)
}
